import React, { useState } from 'react';
import {
  Modal,
  Form,
  Input,
  Select,
  Button,
  DatePicker,
  Checkbox,
  message,
  Row,
  Col
} from 'antd';
import reportService from '../../services/reportService';

const { Option } = Select;
const { RangePicker } = DatePicker;

const CreateReportModal = ({ visible, onCancel, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      // Transform form values to match API schema
      const reportData = {
        name: values.name,
        type: values.reportFrom,
        category: 'analytics',
        config: {
          dataSource: {
            entity: values.reportFrom,
            filters: {
              ...(values.dateRange && values.dateRange[0] && values.dateRange[1] && {
                dateRange: {
                  field: 'createdAt',
                  startDate: values.dateRange[0].toISOString(),
                  endDate: values.dateRange[1].toISOString()
                }
              })
            },
            sortBy: {
              field: 'createdAt',
              order: 'desc'
            }
          },
          visualization: {
            type: values.analytics ? 'bar' : 'table',
            showLegend: true,
            showGrid: true
          },
          display: {
            pagination: {
              enabled: true,
              pageSize: 20
            }
          }
        },
        visibility: 'private'
      };

      console.log('Creating simple report:', reportData);
      const response = await reportService.createReport(reportData);
      
      if (response.success) {
        message.success('Report created successfully!');
        onSuccess(response.data);
        form.resetFields();
      }
    } catch (error) {
      console.error('Failed to create report:', error);
      if (error.response?.data?.errors) {
        message.error(`Validation failed: ${error.response.data.errors.map(e => e.message).join(', ')}`);
      } else if (error.response?.data?.message) {
        message.error(error.response.data.message);
      } else {
        message.error('Failed to create report');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Create New Report"
      open={visible}
      onCancel={onCancel}
      width={600}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Cancel
        </Button>,
        <Button 
          key="submit" 
          type="primary" 
          loading={loading} 
          onClick={handleSubmit}
        >
          Create Report
        </Button>
      ]}
    >
      <Form
        form={form}
        layout="vertical"
        style={{ marginTop: 20 }}
      >
        {/* Report Name */}
        <Form.Item
          name="name"
          label="Name of Report"
          rules={[{ required: true, message: 'Please enter report name' }]}
        >
          <Input placeholder="Enter report name" />
        </Form.Item>

        {/* Report From */}
        <Form.Item
          name="reportFrom"
          label="Report From"
          rules={[{ required: true, message: 'Please select data source' }]}
        >
          <Select placeholder="Select data source">
            <Option value="leads">Leads</Option>
            <Option value="deals">Deals</Option>
            <Option value="meetings">Meetings</Option>
            <Option value="tasks">Tasks</Option>
          </Select>
        </Form.Item>

        {/* Date Range */}
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              name="dateRange"
              label="Date Range"
            >
              <RangePicker 
                style={{ width: '100%' }} 
                placeholder={['Start Date', 'End Date']}
              />
            </Form.Item>
          </Col>
        </Row>

        {/* Analytics Checkbox */}
        <Form.Item
          name="analytics"
          valuePropName="checked"
        >
          <Checkbox>Include Analytics</Checkbox>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateReportModal;
